import YoutubePlayer, {
  YoutubeIframeProps,
  YoutubeIframeRef,
} from 'react-native-youtube-iframe'
import { useEffect, useRef, useState } from 'react'
import { isWeb } from 'tamagui'
import { IUpdateLessonProgress } from '../MediaRender'

interface IYoutubeVideoPlayerProps extends YoutubeIframeProps {
  updateProgress: (params: IUpdateLessonProgress) => void
  videoStartTime?: number
  actualProgress?: number
}

const thresholds = [25, 50, 75, 100] as const

export function YoutubeVideoPlayer({
  videoId,
  height,
  width,
  webViewStyle,
  updateProgress,
  videoStartTime,
  actualProgress = 0,
}: IYoutubeVideoPlayerProps) {
  const playerRef = useRef<YoutubeIframeRef>(null)
  const [duration, setDuration] = useState(0)
  const [progressMarkers, setProgressMarkers] = useState({
    25: actualProgress >= 25,
    50: actualProgress >= 50,
    75: actualProgress >= 75,
    100: actualProgress >= 100,
  })

  useEffect(() => {
    const interval = setInterval(async () => {
      if (!playerRef.current) return

      try {
        const currentTime = await playerRef.current.getCurrentTime()
        const totalDuration = await playerRef.current.getDuration()

        if (totalDuration !== duration) {
          setDuration(totalDuration)
        }

        const progress = (currentTime / totalDuration) * 100

        thresholds.forEach((threshold) => {
          if (progress >= threshold && !progressMarkers[threshold]) {
            setProgressMarkers((prev) => ({ ...prev, [threshold]: true }))
            updateProgress?.({
              progress: threshold,
              currentVideoTime: Math.floor(currentTime),
            })

            if (threshold === 100) {
              clearInterval(interval)
            }
          }
        })
      } catch (error) {
        console.error('Erro ao monitorar progresso do vídeo:', error)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [duration, updateProgress, progressMarkers])

  if (isWeb) return null
  return (
    <YoutubePlayer
      ref={playerRef}
      videoId={videoId}
      height={height}
      width={width}
      useLocalHTML={true}
      webViewStyle={webViewStyle}
      initialPlayerParams={{
        start: videoStartTime,
      }}
    />
  )
}
